export const printLog = [
  {
    address: "*****",
    expressId: "圆通 YT6995086192106",
    orderId: "221228-014019542581248",
    phone: "****",
    printTime: "2022-12-28 14:11:02",
    productName: "TANJI高级文化衫【正直诚信】针织,女士款式",
    reciver: "****",
  },
];
